module.exports = __webpack_public_path__ + "img/image5.6656ed9d.png";